module.exports = __webpack_public_path__ + "img/confirmphone.a7f94b01.png";